import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  listSeries: [],
  listSophistications: [],
  listMagnitudes: [],
  listSizes: [],
  listTypologies: [],

  listProblems: [],
  listComplexities: [],
  listMeasures: [],
  listStrategies: [],
  listAmplitudes: [],
  listMitigations: [],
  listMultimedias: [],
  listPriceRanges: [],
  listPermissionPublish: [],

  listSeriesFilter: [],
  listSophisticationsFilter: [],
  listMagnitudesFilter: [],
  listSizesFilter: [],
  listTypologiesFilter: [],

  listProblemsFilter: [],
  listComplexitiesFilter: [],
  listMeasuresFilter: [],
  listStrategiesFilter: [],
  listAmplitudesFilter: [],
  listMitigationsFilter: [],
  listRangePricesFilter: [],
  listConcernsFilter: [],

  listConcerns: [],
  listGroups:[],
  listConcernsGroup:[],

  listMediaTypes: [],

  listSeries: [],
  listSophistications: [],
  listAmplitudes: [],
  listSizes: [],
  scientifics: [],
  listMitigations: [],
  adaptations: [],
  productions: [],
  services: [],

  fenomenos: [],
  technologyTypes: [],
  multimedia: [],
  fenomenoCategorias: [],
  tamaniosSistema: [],
  ambitosAplicacion: [],
  alcanceTipos: [],
  moduloBusquedaTipos: [],
  esfuerzoTipos: [],
  produccionTipos: [],
  ambitosRegulacion: [],

  enfoqueEstrategias: [],
  enfoqueMedidas: [],
  
  catalog: {},
  listFullCatalogs: [],
  catalogsP: [],
  catalogsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",

  listDataTypes: [],
  listTypeFields: [],
  listComponentNew: [],
  listComponentView: [],
  listCatalogModules: [],
  listRelationComparable: [],
  listStyleTable: [],
};

export const catalogReducer = (state = initialState, action, getState) => {
  switch (action.type) {
    case types.CATALOG_SELECT:
      return {
        ...state,
        catalog: action.payload,
      };

    case types.CATALOG_UPDATE:
      if (state.catalogsS.length > 0) {
        return {
          ...state,
          catalogsS: state.catalogsS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogsP: state.catalogsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogsP: state.catalogsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.CATALOG_DELETE:
      if (state.catalogsS.length > 0) {
        return {
          ...state,
          catalogsS: state.catalogsS.filter((usr) => usr.id !== action.payload),
          catalogsP: state.catalogsP.filter((usr) => usr.id !== action.payload),
          catalog: {},
        };
      } else {
        return {
          ...state,
          catalogsP: state.catalogsP.filter((usr) => usr.id !== action.payload),
          catalog: {},
        };
      }

    case types.CATALOG_START_LOADING_SERIES:
      return {
        ...state,
        listSeries: action.payload,
      };

    case types.CATALOG_START_LOADING_FENOMENO:
      return {
        ...state,
        fenomenos: action.payload,
      };

    case types.CATALOG_START_LOADING_TECHNOLOGY_TYPES:
      return {
        ...state,
        technologyTypes: action.payload,
      };

    case types.CATALOG_START_LOADING_MULTIMEDIA:
      return {
        ...state,
        multimedia: action.payload,
      };

    case types.CATALOG_START_LOADING_FENOMENO_CATEGORIA:
      return {
        ...state,
        fenomenoCategorias: action.payload,
      };

    case types.CATALOG_START_LOADING_TAMANIO_SISTEMA:
      return {
        ...state,
        tamaniosSistema: action.payload,
      };

    case types.CATALOG_START_LOADING_AMBITO_APLICACION:
      return {
        ...state,
        ambitosAplicacion: action.payload,
      };

    case types.CATALOG_START_LOADING_ALCANCE_TIPO:
      return {
        ...state,
        alcanceTipos: action.payload,
      };

    case types.CATALOG_START_LOADING_MODULO_BUSQUEDA_TIPO:
      return {
        ...state,
        moduloBusquedaTipos: action.payload,
      };

    case types.CATALOG_START_LOADING_ESFUERZO_TIPO:
      return {
        ...state,
        esfuerzoTipos: action.payload,
      };

    case types.CATALOG_START_LOADING_PRODUCCION_TIPO:
      return {
        ...state,
        produccionTipos: action.payload,
      };

    case types.CATALOG_START_LOADING_AMBITO_REGULACION:
      return {
        ...state,
        ambitosRegulacion: action.payload,
      };

    case types.CATALOG_START_LOADING_ENFOQUE_ESTRATEGIA:
      return {
        ...state,
        enfoqueEstrategias: action.payload,
      };

    case types.CATALOG_START_LOADING_ENFOQUE_MEDIDA:
      return {
        ...state,
        enfoqueMedidas: action.payload,
      };

    case types.CATALOG_START_LOADING_SOPHISTICATIONS:
      return {
        ...state,
        listSophistications: action.payload,
      };

    case types.CATALOG_START_LOADING_AMPLITUDES:
      return {
        ...state,
        listAmplitudes: action.payload,
      };

    case types.CATALOG_START_LOADING_SIZES:
      return {
        ...state,
        listSizes: action.payload,
      };

    case types.CATALOG_START_LOADING_SCIENTIFICS:
      return {
        ...state,
        scientifics: action.payload,
      };

    case types.CATALOG_START_LOADING_MITIGATIONS:
      return {
        ...state,
        listMitigations: action.payload,
      };

    case types.CATALOG_START_LOADING_ADAPTATIONS:
      return {
        ...state,
        adaptations: action.payload,
      };

    case types.CATALOG_START_LOADING_PRODUCTIONS:
      return {
        ...state,
        productions: action.payload,
      };

    case types.CATALOG_START_LOADING_SERVICES:
      return {
        ...state,
        services: action.payload,
      };

    case types.CATALOG_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogsP: action.payload.catalogsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOG_START_SEARCH:
      return {
        ...state,
        catalogsS: action.payload,
      };

    case types.CATALOG_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogsS: action.payload.catalogsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      debugLogReducer(":: CATALOG_CLEAN_SEARCH_PAGINATED");
      return {
        ...state,
        catalogsS: [],
      };

    case types.CATALOG_CLEAN:
      return {
        ...state,
        catalog: {},
      };

    case types.CATALOG_START_REGISTER:
      return {
        ...state,
        catalog: action.payload,
      };

    case types.CATALOG_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.CATALOG_START_LOADING_ALL:

      return {
        ...state,
        listFullCatalogs: action.payload,
        
        listSeries: action.payload.filter(cat => cat.catalogtype_id === 1),
        
        listSophistications: action.payload.filter(cat => cat.catalogtype_id === 3),
        
        listMagnitudes: action.payload.filter(cat => cat.catalogtype_id === 4),
        
        listSizes: action.payload.filter(cat => cat.catalogtype_id === 5),
        
        listTypologies: action.payload.filter(cat => cat.catalogtype_id === 6),
        listGeneralAdaptations: action.payload.filter(cat => cat.catalogtype_id === 7),
        listStructuralAdaptations: action.payload.filter(cat => cat.catalogtype_id === 8),
        listSpecificAdaptations: action.payload.filter(cat => cat.catalogtype_id === 9),
        listProblems: action.payload.filter(cat => cat.catalogtype_id === 10),
        listComplexities: action.payload.filter(cat => cat.catalogtype_id === 16),
        listMeasures: action.payload.filter(cat => cat.catalogtype_id === 18),
        listStrategies: action.payload.filter(cat => cat.catalogtype_id === 19),
        listAmplitudes: action.payload.filter(cat => cat.catalogtype_id === 20),
        listMitigations: action.payload.filter(cat => cat.catalogtype_id === 21),
        listMultimedias: action.payload.filter(cat => cat.catalogtype_id === 22),
        listPriceRanges: action.payload.filter(cat => cat.catalogtype_id === 23),
        listPermissionPublish: action.payload.filter(cat => cat.catalogtype_id === 62),

        listDataTypes: action.payload.filter(cat => cat.catalogtype_id === 38),
        listTypeFields: action.payload.filter(cat => cat.catalogtype_id === 39),
        listComponentNew: action.payload.filter(cat => cat.catalogtype_id === 40),
        listComponentView: action.payload.filter(cat => cat.catalogtype_id === 41),
        listCatalogModules: action.payload.filter(cat => cat.catalogtype_id === 42),
        listRelationComparable: action.payload.filter(cat => cat.catalogtype_id === 43),
        listStyleTable: action.payload.filter(cat => cat.catalogtype_id === 44),

        listMediaTypes: action.payload.filter(cat => cat.catalogtype_id === 45),

      };

    /*case types.CATALOG_START_LOADING_FILTER:

      const { deep_indicator_min, protection_indicator_min, applicability_indicator_min,
        relevance_indicator_min, mitigation_indicator_min, adaptation_indicator_min,
        performance_indicator_min, deep_indicator_max, protection_indicator_max,
        applicability_indicator_max, relevance_indicator_max, mitigation_indicator_max,
        adaptation_indicator_max, performance_indicator_max, catalogserie_ids,
        catalogsophistication_ids, catalogmagnitude_ids, catalogsize_ids,
        catalogtypology_ids, catalogpricerange_ids, catalogcontinents_ids,
        catalogregions_ids, catalogcountries_ids, catalogproblem_ids,
        catalogciiu_level1_codes, catalogsection_level1_codes, catalogphase_level1_codes
      } = action.payload;

      const catalogSerieIdsList = catalogserie_ids && catalogserie_ids.split(",");
      const catalogSophisticationsIdsList = catalogsophistication_ids && catalogsophistication_ids.split(",");
      const catalogMagnitudesIdsList = catalogmagnitude_ids && catalogmagnitude_ids.split(",");
      const catalogSizesIdsList = catalogsize_ids && catalogsize_ids.split(",");
      const catalogTypologysIdsList = catalogtypology_ids && catalogtypology_ids.split(",");
      const catalogPriceRangesIdsList = catalogpricerange_ids && catalogpricerange_ids.split(",");
      const catalogProblemsIdsList = catalogproblem_ids && catalogproblem_ids.split(",");

      return {
        ...state,

        listSeriesFilter: getFilterCatalog(state.listSeries, catalogSerieIdsList),
        
        listSophisticationsFilter: getFilterCatalog(state.listSophistications, catalogSophisticationsIdsList),
        
        listMagnitudesFilter: getFilterCatalog(state.listMagnitudes, catalogMagnitudesIdsList),
        
        listSizesFilter: getFilterCatalog(state.listSizes, catalogSizesIdsList),
        
        listTypologiesFilter: getFilterCatalog(state.listTypologies, catalogTypologysIdsList),

        listProblemsFilter: getFilterCatalog(state.listProblems, catalogProblemsIdsList),

        listPriceRangesFilter: getFilterCatalog(state.listPriceRanges, catalogPriceRangesIdsList),

        deep_indicator_min: deep_indicator_min,
        deep_indicator_max: deep_indicator_max,
        protection_indicator_min: protection_indicator_min,
        protection_indicator_max: protection_indicator_max,
        applicability_indicator_min: applicability_indicator_min,
        applicability_indicator_max: applicability_indicator_max,
        relevance_indicator_min: relevance_indicator_min,
        relevance_indicator_max: relevance_indicator_max,
        mitigation_indicator_min: mitigation_indicator_min,
        mitigation_indicator_max: mitigation_indicator_max,
        adaptation_indicator_min: adaptation_indicator_min,
        adaptation_indicator_max: adaptation_indicator_max,
        performance_indicator_min: performance_indicator_min,
        performance_indicator_max: performance_indicator_max

      };*/

    case types.CATALOG_START_LOADING_FILTER:

      if (action.payload == null || typeof action.payload !== 'object') {
        return state;
      }

      const {
        deep_indicator_min, protection_indicator_min, applicability_indicator_min, relevance_indicator_min,
        mitigation_indicator_min, adaptation_indicator_min, performance_indicator_min, deep_indicator_max,
        protection_indicator_max, applicability_indicator_max, relevance_indicator_max, mitigation_indicator_max,
        adaptation_indicator_max, performance_indicator_max,
        catalogserie_ids, catalogsophistication_ids, catalogmagnitude_ids,
        catalogsize_ids, catalogtypology_ids, catalogpricerange_ids,
        
        catalogproblem_ids,

        catalogcomplexity_ids,
        
        catalogmeasure_ids, catalogstrategy_ids, catalogamplitude_ids, catalogmitigation_ids,
        catalogconcern_ids

      } = action.payload;

      const catalogSerieIdsList = catalogserie_ids && catalogserie_ids.split(",");
      const catalogSophisticationsIdsList = catalogsophistication_ids && catalogsophistication_ids.split(",");
      const catalogMagnitudesIdsList = catalogmagnitude_ids && catalogmagnitude_ids.split(",");
      const catalogSizesIdsList = catalogsize_ids && catalogsize_ids.split(",");
      const catalogTypologysIdsList = catalogtypology_ids && catalogtypology_ids.split(",");
      const catalogPriceRangesIdsList = catalogpricerange_ids && catalogpricerange_ids.split(",");
      const catalogProblemsIdsList = catalogproblem_ids && catalogproblem_ids.split(",");

      const catalogcomplexity_idsList = catalogcomplexity_ids && catalogcomplexity_ids.split(",");
      const catalogmeasure_idsList = catalogmeasure_ids && catalogmeasure_ids.split(",");
      const catalogstrategy_idsList = catalogstrategy_ids && catalogstrategy_ids.split(",");
      const catalogamplitude_idsList = catalogamplitude_ids && catalogamplitude_ids.split(",");
      const catalogmitigation_idsList = catalogmitigation_ids && catalogmitigation_ids.split(",");

       const catalogconcern_idsList = catalogconcern_ids && catalogconcern_ids.split(",");

      return {
        ...state,
        listSeriesFilter: getFilterCatalog(state.listSeries, catalogSerieIdsList),
        listSophisticationsFilter: getFilterCatalog(state.listSophistications, catalogSophisticationsIdsList),
        listMagnitudesFilter: getFilterCatalog(state.listMagnitudes, catalogMagnitudesIdsList),
        listSizesFilter: getFilterCatalog(state.listSizes, catalogSizesIdsList),
        listTypologiesFilter: getFilterCatalog(state.listTypologies, catalogTypologysIdsList),
        listProblemsFilter: getFilterCatalog(state.listProblems, catalogProblemsIdsList),
        listPriceRangesFilter: getFilterCatalog(state.listPriceRanges, catalogPriceRangesIdsList),

        listComplexitiesFilter: getFilterCatalog(state.listComplexities, catalogcomplexity_idsList),
        listMeasuresFilter: getFilterCatalog(state.listMeasures, catalogmeasure_idsList),
        listStrategiesFilter: getFilterCatalog(state.listStrategies, catalogstrategy_idsList),
        listAmplitudesFilter: getFilterCatalog(state.listAmplitudes, catalogamplitude_idsList),
        listMitigationsFilter: getFilterCatalog(state.listMitigations, catalogmitigation_idsList),

        listConcernsFilter: getFilterCatalog(state.listConcerns, catalogconcern_idsList),

        deep_indicator_min: deep_indicator_min,
        deep_indicator_max: deep_indicator_max,
        protection_indicator_min: protection_indicator_min,
        protection_indicator_max: protection_indicator_max,
        applicability_indicator_min: applicability_indicator_min,
        applicability_indicator_max: applicability_indicator_max,
        relevance_indicator_min: relevance_indicator_min,
        relevance_indicator_max: relevance_indicator_max,
        mitigation_indicator_min: mitigation_indicator_min,
        mitigation_indicator_max: mitigation_indicator_max,
        adaptation_indicator_min: adaptation_indicator_min,
        adaptation_indicator_max: adaptation_indicator_max,
        performance_indicator_min: performance_indicator_min,
        performance_indicator_max: performance_indicator_max
      };

    case types.CATALOG_START_LOADING_BY_GROUP_VISION:
    return {
        ...state,
        listConcernsGroup: action.payload,
      };

    case types.CATALOG_CLEAN_CONCERN_BY_GROUP_VISION:
    return {
        ...state,
        listConcernsGroup: [],
      };

    case types.CATALOG_SET_TOPIC_QUESTION_LISTS:
      return {
        ...state,
        listGroups: action.payload.groups || [],
        listConcerns: action.payload.concerns || []
      };


    default:
      return state;
  }
};

const getFilterCatalog = (arrayFull, uniqueArray) => {
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      
      for (const elemSearch of arrayFull) {
        
        if (parseInt(idUniqueFound) === elemSearch.id) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }

  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;

}
